import axios from 'axios';
import store from '@/store'

const baseURL = process.env.VUE_APP_ENGINE_URL;

const state = {
  allReports: [],
  reportAction: '',
  rTitle: '',
  rDesc: '',
  rSql: '',
  rGroups: [],
  rData: [],
  reportId: null,
  reportSqlData: [],
  savedReport: [],
  reportLocked: false,
  reportLockedUser: '',
  lockedReports: [],
  copiedReport: null,
  deletedReport: null,
  fieldsReady: false,
  editingReport: false,
  promoteReportData: [],
  promoteReportRes: []
};

const getters = {
  allReports: (state) => state.allReports,
  reportAction: (state) => state.reportAction,
  rTitle: (state) => state.rTitle,
  rDesc: (state) => state.rDesc,
  rSql: (state) => state.rSql,
  rGroups: (state) => state.rGroups,
  rData: (state) => state.rData,
  reportId: (state) => state.reportId,
  reportSqlData: (state) => state.reportSqlData,
  reportLocked: (state) => state.reportLocked,
  reportLockedUser: (state) => state.reportLockedUser,
  lockedReports: (state) => state.lockedReports,
  promoteReportData: (state) => state.promoteReportData,
  promoteReportRes: (state) => state.promoteReportRes
};

const actions = {
  getAllReports({commit}) {
    let data = {
      'variables': {
        'requestType': { 'value': 'getAll', 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    
    return axios.post(baseURL + '/process-definition/key/reportController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      commit('ALL_REPORTS', JSON.parse(result.data.variables.reports.value));
    }).catch(error => {
      let msg = 'Possible error in SQL statement. ' + error;
      commit('ERROR_MESSAGE', msg);
    });
  },
  getReport({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'get', 'type': 'String' },
        'reportId': { 'value': payload.reportId, 'type': 'Integer' },
        'reportAction': { 'value': payload.reportAction, 'type': 'String' },
        'lockedBy': { 'value': payload.lockedBy, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    
    return axios.post(baseURL + '/process-definition/key/reportController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      commit('REPORT_TITLE', result.data.variables.reportTitle.value);
      commit('REPORT_DESC', result.data.variables.reportDesc.value);
      commit('REPORT_SQL', result.data.variables.reportSql.value);
      commit('REPORT_GROUPS', JSON.parse(result.data.variables.reportGroups.value));
      commit('REPORT_DATA', JSON.parse(result.data.variables.reportData.value));
    }).catch(error => {
      let msg = 'Possible error in SQL statement. ' + error;
      commit('ERROR_MESSAGE', msg);
    });
  },
  copyReport({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'save', 'type': 'String' },
        'reportAction': { 'value': 'copy', 'type': 'String' },
        'reportId': { 'value': payload.reportId, 'type': 'Integer' },
        'createdOn': { 'value': payload.createdOn, 'type': 'String' },
        'createdBy': { 'value': payload.createdBy, 'type': 'String' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/reportController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {            
      commit('COPIED_REPORT', payload.reportId);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteReport({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'delete', 'type': 'String' },
        'reportId': { 'value': payload.reportId, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/reportController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {            
      commit('DELETED_REPORT', payload.reportId);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  reportLockCheck({commit}, payload) {
    let data = {};
    if(payload.checkType == 'single') {
      data = {
        'variables': {
          'requestType': { 'value': 'lockCheck', 'type': 'String' },
          'reportId': { 'value': payload.reportId, 'type': 'Integer' },
          'checkType': { 'value': payload.checkType, 'type': 'String' }
        },
        'withVariablesInReturn': true
      };
    }
    if(payload.checkType == 'all') {
      data = {
        'variables': {
          'requestType': { 'value': 'lockCheck', 'type': 'String' },
          'reportId': { 'value': 0, 'type': 'Integer' },
          'checkType': { 'value': payload.checkType, 'type': 'String' }
        },
        'withVariablesInReturn': true
      };
    }
    if(payload.checkType == 'unlock') {
      data = {
        'variables': {
          'requestType': { 'value': 'lockCheck', 'type': 'String' },
          'reportId': { 'value': payload.reportId, 'type': 'Integer' },
          'checkType': { 'value': payload.checkType, 'type': 'String' }
        },
        'withVariablesInReturn': true
      };
    }
    return axios.post(baseURL + '/process-definition/key/reportController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      if(payload.checkType == 'single') {
        let retData = {
          'reportLocked': result.data.variables.reportLocked.value,
          'reportLockedUser': result.data.variables.reportLockedUser.value
        };
        commit('REPORT_LOCK_CHECK', retData);
      }
      if(payload.checkType == 'all') {
        let lockedReports = JSON.parse(result.data.variables.lockedReports.value);
        commit('REPORT_LOCK_CHECK_ALL', lockedReports);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  runReport({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'run', 'type': 'String' },
        'reportSql': { 'value': payload.reportSql, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };

    return axios.post(baseURL + '/process-definition/key/reportController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      
      if(result.data.variables.sqlData) {
        commit('REPORT_SQL_DATA', JSON.parse(result.data.variables.sqlData.value));
      }
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'Possible error in SQL statement. ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  saveReport({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'save', 'type': 'String' },
        'reportId': { 'value': payload.reportId, 'type': 'Integer' },
        'reportAction': { 'value': payload.reportAction, 'type': 'String' },
        'reportData': { 'value': payload.reportData, 'type': 'Json' },
        'reportTitle': { 'value': payload.reportTitle, 'type': 'String' },
        'reportDesc': { 'value': payload.reportDesc, 'type': 'String' },
        'reportGroups': { 'value': payload.reportGroups, 'type': 'Json' },
        'reportSql': { 'value': payload.reportSql, 'type': 'String' },
        'createdBy': { 'value': payload.createdBy, 'type': 'String' },
        'createdOn': { 'value': payload.createdOn, 'type': 'String' },
        'updatedBy': { 'value': payload.updatedBy, 'type': 'String' },
        'updatedOn': { 'value': payload.updatedOn, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };

    return axios.post(baseURL + '/process-definition/key/reportController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      if(typeof result.data.variables.lastId !== 'undefined') {
        commit('UPDATE_REPORT_ID', result.data.variables.lastId.value);
      }
      commit('SAVED_REPORT', result.data);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'Possible error in SQL statement. ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  promoteReportsCheck({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'promote', 'type': 'String' },
        'promoteReportData': { 'value': payload.promotes, 'type': 'Json' },
        'checkType': { 'value': 'get', 'type': 'String' },
      },
      'withVariablesInReturn': true
    };
    return axios.post(payload.engine + '/engine-rest/process-definition/key/reportController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      let reportData = JSON.parse(result.data.variables.reportData.value);
      commit('PROMOTE_REPORT_DATA', reportData);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'API error: ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  promoteReports({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'promote', 'type': 'String' },
        'promoteReportData': { 'value': payload.promotes, 'type': 'Json' },
        'checkType': { 'value': 'getLocal', 'type': 'String' },
      },
      'withVariablesInReturn': true
    };
    return axios.post(baseURL + '/process-definition/key/reportController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      let reportData = result.data.variables.reportData.value;
      
      let data = {
        'variables': {
          'requestType': { 'value': 'promote', 'type': 'String' },
          'promoteReportData': { 'value': reportData, 'type': 'Json' },
          'checkType': { 'value': 'update', 'type': 'String' },
        },
        'withVariablesInReturn': true
      };
      return axios.post(payload.engine + '/engine-rest/process-definition/key/reportController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {        
        let retData = [];

        if(result.status == 200) {
          retData = JSON.parse(result.data.variables.retData.value);
        }

        commit('PROMOTE_REPORT_RES', retData);
      }).catch(error => {
        if(error != 'TypeError: data is null') {
          let msg = 'API error: ' + error;
          commit('ERROR_MESSAGE', msg);
        }
      });
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'API error: ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  }
};

const mutations = {
  ALL_REPORTS(state, payload) {
    state.allReports = payload;
  },
  REPORT_TITLE(state, payload) {
    state.rTitle = payload;
  },
  REPORT_DESC(state, payload) {
    state.rDesc = payload;
  },
  REPORT_SQL(state, payload) {
    state.rSql = payload;
  },
  REPORT_GROUPS(state, payload) {
    state.rGroups = payload;
  },
  REPORT_DATA(state, payload) {
    state.rData = payload;
  },
  UPDATE_REPORT_ACTION(state, payload) {
    state.reportAction = payload;
  },
  UPDATE_REPORT_ID(state, payload) {
    state.reportId = payload;
  },
  SAVED_REPORT(state, payload) {
    state.savedReport = payload;
  },
  REPORT_SQL_DATA(state, payload) {
    state.reportSqlData = payload;
  },
  REPORT_LOCK_CHECK(state, payload) {
    state.reportLocked = payload.reportLocked;
    state.reportLockedUser = payload.reportLockedUser;
  },
  REPORT_LOCK_CHECK_ALL(state, payload) {
    state.lockedReports = payload;
  },
  COPIED_REPORT(state, payload) {
    state.copiedReport = payload;
  },
  DELETED_REPORT(state, payload) {
    state.deletedReport = payload;
  },
  FIELDS_READY(state, payload) {
    state.fieldsReady = payload;
  },
  EDITING_REPORT(state, payload) {
    state.editingReport = payload;
  },
  PROMOTE_REPORT_DATA(state, payload) {
    state.promoteReportData = payload;
  },
  PROMOTE_REPORT_RES(state, payload) {
    state.promoteReportRes = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}